import { render, staticRenderFns } from "./place.vue?vue&type=template&id=5f2c35d0&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c35d0",
  null
  
)

export default component.exports